import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Qyjx1 from './img/qyjx1.jpg';
import Qyjx2 from './img/qyjx2.jpg';
import Qyjx3 from './img/qyjx3.png';
import Qyjx4 from './img/qyjx4.png';
import Shgl5 from './img/shgl5.jpg';
import Dgly1 from './img/dgly1.jpg';
import Shdd1 from './img/shdd1.jpg';
import Shss1 from './img/shss1.jpg';
import Zjyb1 from './img/zjyb1.JPG';
import Rssx1 from './img/rssx1.jpg';
import './PremiumNews.css';

class News extends Component {
    render() {
        // 企业践习项目数据
        const projects = [
            {
                id: 1,
                title: "上海光联照明有限公司参观",
                image: Shgl5,
                description: "学生参观上海光联照明有限公司，了解现代照明技术的发展和应用。通过实地参观，学生了解了LED照明产品的设计、生产和测试流程，对光电技术的实际应用有了更深入的认识。"
            },
            {
                id: 2,
                title: "德国莱茵集团参观",
                image: Dgly1,
                description: "学生参观德国莱茵集团，了解国际领先的检测认证技术和质量管理体系。通过与企业技术人员的交流，学生对产品质量控制和国际标准有了更深刻的理解。"
            },
            {
                id: 3,
                title: "上海电动工具研究所（集团）有限公司参观",
                image: Shdd1,
                description: "学生参观上海电动工具研究所（集团）有限公司，了解电动工具的研发、设计和制造流程。通过实地参观，学生了解了电动工具产品的设计原理、生产工艺和质量检测标准，对机电一体化技术的实际应用有了更深入的认识。"
            },
            {
                id: 4,
                title: "上海三思电子工程有限公司参观",
                image: Shss1,
                description: "学生参观上海三思电子工程有限公司，了解LED显示系统和智能交通产品的研发与生产流程。通过实地参观，学生了解了LED显示屏的设计原理、生产工艺和质量控制标准，对光电技术在智慧城市领域的应用有了更深入的认识。"
            },
            {
                id: 5,
                title: "浙江友邦集成吊顶股份有限公司参观",
                image: Zjyb1,
                description: "学生参观浙江友邦集成吊顶股份有限公司，了解集成吊顶产品的设计、研发和生产流程。通过实地参观，学生了解了现代建筑装饰材料的生产工艺、质量控制体系和产品创新理念，对建筑装饰行业的发展趋势有了更深入的认识。"
            },
            {
                id: 6,
                title: "认识实习",
                image: Rssx1,
                description: "学生前往江苏芯梦半导体设备有限公司和华世德电子科技有限公司进行认识实习，深入了解半导体设备制造和电子科技行业的生产流程和技术应用。通过实地参观和学习，学生对相关行业的技术发展和产业现状有了更全面的认识，为后续的专业学习和职业规划奠定了基础。"
            }
        ];

        return (
            <div className="premium-news" id="c">
                <div className="premium-news-container">
                    <div className="premium-news-grid">
                        {projects.map(project => (
                            <Link to={`/enterprise-project/${project.id}`} key={project.id} className="premium-news-card">
                                <img className="premium-news-image" src={project.image} alt={project.title} />
                                <div className="premium-news-content">
                                    <h3 className="premium-news-name">{project.title}</h3>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default News;